module.exports = __webpack_public_path__ + "img/icon_option_set_6.ae84c914.svg";